// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__1H_3k","header":"MergedInvoice_header__vrZro"};